// 메트로놈 박자표·묶음·강세 규칙 (순수 함수 — beatLayout과 함께 단위 테스트 대상)

// 박자표 빠른 선택: 위 줄 4분음표 박자, 아래 줄 8분음표 박자 + 직접 설정 (5칸 고정 두 줄 → 줄바꿈 없음)
export const QUICK_SIGNATURES = [
  [2, 4], [3, 4], [4, 4], [5, 4], [6, 4],
  [3, 8], [6, 8], [9, 8], [12, 8],
];

export const BEAT_UNITS = [2, 4, 8, 16];
export const MAX_BEATS = 16;

// 강세 단계: 0 무음 · 1 약 · 2 중 · 3 강
export const ACCENT_LEVELS = 4;

export function parseGrouping(str) {
  if (!str) return null;
  const parts = String(str).split('+').map(Number);
  return parts.every((n) => Number.isInteger(n) && n > 0) ? parts : null;
}

export function groupingKey(groups) {
  return groups && groups.length > 1 ? groups.join('+') : null;
}

const sum = (arr) => arr.reduce((a, b) => a + b, 0);

// 2와 3으로 N을 나누되 3을 한 번만 쓰는 배치 (홀수 박: 2+2+3, 2+3+2, 3+2+2 …)
function singleThreeSplits(n) {
  if (n < 5 || n % 2 === 0) return [];
  const twos = (n - 3) / 2;
  const out = [];
  for (let pos = twos; pos >= 0; pos--) {
    const g = Array(twos).fill(2);
    g.splice(pos, 0, 3);
    out.push(g);
  }
  return out;
}

// 박자표에서 고를 수 있는 묶음 목록. 첫 번째가 기본값이다.
export function groupingOptions(beats, unit) {
  const opts = [];
  const add = (g) => {
    if (sum(g) !== beats) return;
    if (!opts.some((o) => o.join('+') === g.join('+'))) opts.push(g);
  };
  const even = (size) => Array(beats / size).fill(size);
  const compound = unit >= 8 && beats > 3 && beats % 3 === 0;

  if (compound) add(even(3));
  if (unit >= 8 && beats % 2 === 1) singleThreeSplits(beats).forEach(add);
  add([beats]); // 묶음 없음
  if (!compound && beats > 4 && beats % 3 === 0) add(even(3));
  if (beats > 4 && beats % 4 === 0) add(even(4));
  if (beats > 4 && beats % 2 === 0) {
    // 3을 앞에 모으고 2로 마무리 (8 → 3+3+2, 10 → 3+3+2+2)
    const threes = Math.floor((beats - 2) / 3);
    for (let t = threes; t >= 2; t--) {
      const rest = beats - t * 3;
      if (rest > 0 && rest % 2 === 0) {
        add([...Array(t).fill(3), ...Array(rest / 2).fill(2)]);
        break;
      }
    }
  }
  if (unit < 8 && beats % 2 === 1) singleThreeSplits(beats).forEach(add);
  return opts.slice(0, 8);
}

// 묶음 기준 기본 강세: 마디 첫 박 강, 묶음 첫 박 중, 나머지 약
export function defaultAccents(groups) {
  const out = [];
  groups.forEach((g, gi) => {
    for (let k = 0; k < g; k++) out.push(gi === 0 && k === 0 ? 3 : k === 0 ? 2 : 1);
  });
  return out;
}

// 화면 표시용 묶음: 묶음이 없고 9박 이상이면 4박씩 끊어 보여준다 (소리·강세에는 영향 없음)
export function displayGroups(beats, groups) {
  if (groups && groups.length > 1) return groups;
  if (beats <= 8) return [beats];
  const out = [];
  for (let i = 0; i < beats; i += 4) out.push(Math.min(4, beats - i));
  return out;
}

// 빠르기말 (BPM 상한 기준)
const TEMPO_NAMES = [
  [40, 'Grave'], [60, 'Largo'], [66, 'Larghetto'], [76, 'Adagio'], [108, 'Andante'],
  [120, 'Moderato'], [156, 'Allegro'], [176, 'Vivace'], [200, 'Presto'], [Infinity, 'Prestissimo'],
];

export function tempoName(bpm) {
  return TEMPO_NAMES.find(([max]) => bpm < max)[1];
}
